import { cn } from '@/lib/utils'

interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  /** Hide the logo glyph and render just the text. Useful inside very tight headers. */
  iconOnly?: boolean
  /** Hide the text and render just the glyph. Mirror of iconOnly. */
  textOnly?: boolean
  className?: string
}

const SIZE_TEXT = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-4xl',
  xl: 'text-6xl',
} as const

const SIZE_ICON = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-12',
  xl: 'size-20',
} as const

/**
 * Brand mark = the shield logo + "e404" text. The shield is the real
 * Android launcher foreground (purple/violet pilot insignia) copied to
 * `/public/e404-logo.webp`. The text retains the gradient on the
 * numerals so the brand reads the same with or without the glyph.
 */
export function Wordmark({
  size = 'md',
  iconOnly = false,
  textOnly = false,
  className,
}: WordmarkProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-2', className)}
      aria-label="e404"
    >
      {!textOnly && (
        <img
          src="/e404-logo.webp"
          alt=""
          aria-hidden
          className={cn(
            'shrink-0 select-none',
            SIZE_ICON[size],
          )}
          loading="eager"
          decoding="async"
        />
      )}
      {!iconOnly && (
        <span
          className={cn(
            'font-display font-bold tracking-tighter inline-flex items-baseline',
            SIZE_TEXT[size],
          )}
          aria-hidden={!textOnly}
        >
          <span className="text-fg">e</span>
          <span className="gradient-text">404</span>
        </span>
      )}
    </span>
  )
}
